<template>
  <div class="br-page-header">
    <div class="br-page-header__copy">
      <div class="br-page-header__title-row">
        <component :is="titleTag" class="br-page-header__title">{{ title }}</component>
        <slot name="title-extra" />
      </div>
      <p class="br-page-header__desc">{{ description }}</p>
    </div>
    <b-button
      variant="primary"
      class="business-documents__primary-btn"
      :disabled="addDisabled"
      @click="$emit('add')"
    >
      <feather type="plus" :size="20" class="business-documents__primary-btn-icon" />
      {{ $t('lbl_EMPBE_BR_AddDocument') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'BrPageHeader',
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    /** 供应商页用 h1，管理端 Tab 内用 h2 */
    titleTag: {
      type: String,
      default: 'h1',
      validator: (v) => ['h1', 'h2'].includes(v),
    },
    addDisabled: { type: Boolean, default: false },
  },
};
</script>
